/* tslint:disable */
/* eslint-disable */
/**
 * VerCasa API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AuthLoginRequest
 */
export interface AuthLoginRequest {
    /**
     * 
     * @type {string}
     * @memberof AuthLoginRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof AuthLoginRequest
     */
    password: string;
}

/**
 * Check if a given object implements the AuthLoginRequest interface.
 */
export function instanceOfAuthLoginRequest(value: object): value is AuthLoginRequest {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('password' in value) || value['password'] === undefined) return false;
    return true;
}

export function AuthLoginRequestFromJSON(json: any): AuthLoginRequest {
    return AuthLoginRequestFromJSONTyped(json, false);
}

export function AuthLoginRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthLoginRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'password': json['password'],
    };
}

export function AuthLoginRequestToJSON(value?: AuthLoginRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'email': value['email'],
        'password': value['password'],
    };
}

